import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useNavigate, useSearchParams } from 'react-router';

import { api } from '../../api';
import { Card } from '../../components/on-boarding/Card';
import { OnBoardingLayout } from '../on-boarding/on-boarding.layout';
import { Space } from '../../app/entities';
import { SelectSpace } from './components/select-space';
import { CreateSpace } from './components/create-space';
import { catchError } from '../../core/catch-error';
import { PageLoader } from '../../app/components/page-loader';
import {
  MarketplaceSubscriptionDetails,
  SubscriptionDetailsPage,
} from './components/subscription-details';

export const MarketplaceLandingPage: React.FC = () => {
  const spaces = Space.getAll();

  const navigate = useNavigate();
  const [isReady, setIsReady] = useState(false);
  const [selectedSpace, setSelectedSpace] = useState<Space | undefined>(spaces[0]);
  const [showCreateSpace, setShowCreateSpace] = useState<boolean>(spaces.length === 0);
  const [subscriptionDetails, setSubscriptionDetails] = useState<MarketplaceSubscriptionDetails>();
  const [searchParams] = useSearchParams();

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      // navigate('/');
      return;
    }

    resolveSubscription().then(() => {
      setIsReady(true);
    });
  }, []);

  const resolveSubscription = async () => {
    try {
      const res = await api.post(`/payment/subscriptions/resolve`, {
        purchaseToken: token,
      });

      if (!res || res.status !== 200) {
        // navigate('/');
        return;
      }

      setSubscriptionDetails(res.data);
    } catch (err) {
      // navigate('/');
    }
  };

  const activateSubscription = async (spaceId: string) => {
    try {
      const res = await api.post(`/payment/spaces/${spaceId}/subscriptions/activate`, {
        purchaseToken: token,
      });

      if (!res || res.status !== 200) {
        return;
      }

      const space = Space.getOne(spaceId);

      if (space) {
        space.subscription = res.data.subscription;
        space.storage = res.data.storage;
        space.seats = res.data.seats;
      }

      navigate(`/marketplace/thanks?spaceId=${space?._id}`);
    } catch (err) {
      catchError(err);
    }
  };

  if (!isReady || !subscriptionDetails) {
    return <PageLoader />;
  }

  return (
    <OnBoardingLayout>
      <Container id="landing-page">
        <Card title="Activate your subscription">
          <SubscriptionDetailsPage subscription={subscriptionDetails} />

          <Separator />

          {!showCreateSpace ? (
            <SelectSpace
              spaces={spaces}
              setSelectedSpace={setSelectedSpace}
              selectedSpace={selectedSpace}
              setShowCreateSpace={setShowCreateSpace}
              activateSubscription={activateSubscription}
            />
          ) : (
            <CreateSpace
              setShowCreateSpace={setShowCreateSpace}
              activateSubscription={activateSubscription}
            />
          )}
        </Card>
      </Container>
    </OnBoardingLayout>
  );
};

const Container = styled.div`
  max-width: 48rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3.2rem;
`;

const Separator = styled.hr`
  border: 1px solid var(--color-grey-8);
`;
